const autoAllocationStatuses = {
  IDLE: 'Idle',
  RUNNING: 'Running',
  LOOKINGFORVALIDPROPOSALS: 'LookingForValidProposals',
  LOOKINGFORPOSTINGS: 'LookingForPostings',
  VALIDATINGTARGETSFORPROPOSAL: 'ValidatingTargetsForProposal',
  TRYINGTOALLOCATE: 'TryingToAllocate',
  STOPPED: 'Stopped',
  PROCESSINGREDRAGSTATUSES: 'ProcessingRedRagStatuses',
  PROCESSINGAMBERRAGSTATUSES: 'ProcessingAmberRagStatuses',
  PROCESSINGGREENRAGSTATUSES: 'ProcessingGreenRagStatuses',
  CHECKFORNEWPROPOSALSFOREXISTINGVISITSATSAMEPOSTCODE: 'CheckForNewProposalsForExistingVisitsAtSamePostCode',
};

export default autoAllocationStatuses;
